
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sprawdz-dostepnosc/usluga-niedostepna",
      function () {
        return require("private-next-pages/sprawdz-dostepnosc/usluga-niedostepna.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sprawdz-dostepnosc/usluga-niedostepna"])
      });
    }
  